import React from 'react';
import GuestStart from './components/GuestStart';
import './App.css';

function App() {
  return (
    <div className="App">
      <GuestStart />
    </div>
  );
}

export default App;
